import { createFileRoute } from "@tanstack/react-router";
import { ConvertTab } from "../-agents/convert-tab";

export const Route = createFileRoute("/agents/figma-convert/")({
  component: ConvertTab,
});
